/**
 * Получение списка тарифов
 */
const getTariffs = function() {
  return new Promise((resolve, reject) =>
    this.request({
      method: "POST",
      url: "/tariff/getTariffs"
    })
      .then(resolve)
      .catch(reject)
  );
};

/**
 * Заявка на смену тарифа (пока письмо)
 */
const sendToChangeTariff = function(data) {
  return new Promise((resolve, reject) =>
    this.request({
      method: "POST",
      url: "/tariff/sendToChangeTariff",
      data: data
    })
      .then(resolve)
      .catch(reject)
  );
};

/**
 * Заявка на подключение функции (пока письмо)
 */
const sendToChangeTariffFunction = function(data) {
  return new Promise((resolve, reject) =>
    this.request({
      method: "POST",
      url: "/tariff/sendToFunction",
      data: data
    })
      .then(resolve)
      .catch(reject)
  );
};

export { getTariffs, sendToChangeTariff, sendToChangeTariffFunction };
